import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext, useEffect, useState } from 'react';
import { checkUserInfo } from '@miro-site/core';
import { HeaderDataContext } from '../context/header-data-context';
export var isUserLoggedIn = function isUserLoggedIn() {
  var _ref = checkUserInfo() || {},
      userId = _ref.id;

  return Number(userId) > 0;
};
export var useHeaderData = function useHeaderData() {
  var _useState = useState(false),
      isLoggedIn = _useState[0],
      setIsUserLoggedIn = _useState[1];

  var headerData = useContext(HeaderDataContext);
  useEffect(function () {
    setIsUserLoggedIn(isUserLoggedIn());
  }, [setIsUserLoggedIn]);

  if (!headerData) {
    return headerData;
  }

  return _objectSpread(_objectSpread({}, headerData), {}, {
    isLoggedIn: isLoggedIn
  });
};